/**
 * MedCaddy API Client - Insurance Module
 * Handles insurance policies CRUD.
 */

import { apiFetch, assertOk, assertOkWithDetail } from './core';

// Insurance API
export const insurance = {
  async list() {
    const response = await apiFetch('/insurance');
    assertOk(response, 'Failed to fetch insurance policies');
    return response.json();
  },

  async create(policy) {
    const response = await apiFetch('/insurance', {
      method: 'POST',
      body: JSON.stringify(policy)
    });
    await assertOkWithDetail(response, 'Failed to create insurance policy');
    return response.json();
  },

  async update(id, policy) {
    const response = await apiFetch(`/insurance/${id}`, {
      method: 'PUT',
      body: JSON.stringify(policy)
    });
    await assertOkWithDetail(response, 'Failed to update insurance policy');
    return response.json();
  },

  async remove(id) {
    const response = await apiFetch(`/insurance/${id}`, {
      method: 'DELETE'
    });
    assertOk(response, 'Failed to delete insurance policy');
  }
};
